import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { makeConfigUrls } from '../utils/configUrls';

/**
 * Hook to navigate to a forum discussion detail page from outside the ForumProvider context.
 *
 * Use this hook when you need to navigate to a forum discussion from components that are not
 * wrapped by ForumProvider (e.g., content recommendations).
 */
export const useNavigateToForumDetail = () => {
  const navigate = useNavigate();
  const urls = makeConfigUrls();

  const onClick = useCallback(
    (id: number) => {
      const url = urls.discussionUrl(id);

      navigate(url);
    },
    [navigate, urls],
  );

  return { onClick };
};
